import request from '@/utils/request'

export const save = params =>
  request.post('/customer-api/bureau-report/add', params, { timeout: 300000 })
